import { cn } from '@lib/utils';
import { type ComponentProps, memo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

type ResponseProps = ComponentProps<typeof ReactMarkdown>;

export const Response = memo(
  ({ className, ...props }: ResponseProps) => (
    <ReactMarkdown
      className={cn(
        'prose prose-sm max-w-none dark:prose-invert',
        '[&>*:first-child]:mt-0 [&>*:last-child]:mb-0',
        '[&_pre]:overflow-x-auto [&_pre]:rounded-md [&_pre]:bg-muted [&_pre]:p-4',
        '[&_code]:rounded [&_code]:bg-muted [&_code]:px-1 [&_code]:py-0.5',
        '[&_pre_code]:bg-transparent [&_pre_code]:p-0',
        'group-[.is-user]:prose-invert group-[.is-user]:text-white',
        className,
      )}
      remarkPlugins={[remarkGfm]}
      {...props}
    />
  ),
  (prevProps, nextProps) => prevProps.children === nextProps.children,
);

Response.displayName = 'Response';
